import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import BankInformation from "./common/BankInformation/BankInformation";
import ProfilePage from "./common/ProfilePage/ProfilePage";
import CorrespondentBanks from "./common/CorrespondentBanks/CorrespondentBanks";
import EditUserModal from "./common/Modals/EditUserModal";
import EditBankModal from "./common/Modals/EditBankModal";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  userGetProfile,
  userPatchProfile,
  userSetProfile,
} from "../../../../store/user/actions";
import PreloaderData from "../../../../components/PreloaderData/index";
import { getPositionsList } from "../../../../store/positions/actions";
import {
  getBankDetailsForUser,
  updateBankDetails,
  addBankDetails,
  setBankDetailsForUser,
  deleteBankDetails,
} from "../../../../store/bank-details/actions";
import {
  getBankCorespondents,
  deleteBankCorespondent,
  updateBankCorespondent,
  addBankCorespondent,
} from "../../../../store/bank-corespondents/actions";
import {
  deleteUserPayoutConditions,
  updateUserPayoutConditions,
  getUserPayoutConditions,
  addUserPayoutConditions,
} from "../../../../store/user-payout-conditions/actions";
import {
  deleteUserSalaryConditions,
  updateUserSalaryConditions,
  getUserSalaryConditions,
  addUserSalaryConditions
} from "../../../../store/user-salary-conditions/actions";
import { getLegalEntityList } from "../../../../store/legal-entity/actions";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';
import PayoutCondition from "./common/Payout/PayoutCondition";
import SalaryCondition from "./common/Payout/SalaryConditions";
import BankDetails from "./common/BankDetails";

const UserProfile = props => {
  const {
    userGetProfile,
    userPatchProfile,
    positions,
    match,
    updateBankDetails,
    addBankDetails,
    deleteBankDetails,
    permissions,
  } = props;

  const canEditPosition = React.useMemo(() => {
    return (
      permissions["is_admin"] ||
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"]
    );
  }, [permissions]);

  const [toggleTab, setToggleTab] = React.useState("profile");
  const [editProfile, setEditProfile] = React.useState(false);
  const [editBank, setEditBank] = React.useState(false);
  const [deleteAlert, setDeleteAlert] = React.useState(false);
  const [editData, setEditData] = React.useState({});
  const profileData = props.profile;

  const languages = [
    {
      label: "Russian",
      value: "ru",
    },
    {
      label: "English",
      value: "en",
    },
  ];

  React.useEffect(() => {
    const client_id = match.params.userId;
    let data_corespondents = props.bankCorespondents;
    let entity_data = props.legal_entity_data;
    entity_data["sizePerPage"] = 0;
    data_corespondents["bank_details"] = client_id;
    userGetProfile(client_id);
    props.getBankDetailsForUser(client_id);

    // props.getUserPayoutConditions({})
    // props.getUserSalaryConditions({})

    if (canEditPosition) {
      props.getPositionsList({
        ...props.positions,
        sizePerPage: 30,
      });
    }

    props.getBankCorespondents(data_corespondents);
    props.getLegalEntityList(entity_data);

    const hash = props.location.hash.split("#").join("") || "profile";
    props.history.location.hash = hash;
    toggle(hash);

    return () => {
      props.userSetProfile({});
      props.setBankDetailsForUser({});
    };
  }, []);

  React.useEffect(() => {
    const hash = props.location.hash.split("#").join("") || "profile";
    toggle(hash);
  }, [props.location.hash]);

  const toggle = tab => {
    if (toggleTab !== tab) {
      setToggleTab(tab);
    }
  };

  const closeEditProfile = () => {
    setEditProfile(false);
  };

  const closeEditBank = () => {
    setEditBank(false);
  };

  const openEditBank = (bankInfo) => {
    setEditData(bankInfo);
    setEditBank(true);
  }

  const applyDeleteBankDetails = id => {
    props.deleteBankDetails(id);
    setDeleteAlert(false);
    setEditBank(false);
  };
  return (
    <React.Fragment>
      {Object.keys(profileData).length !== 0 ? (
        <div className="page-content">
          <ModifiedMetaTags title="Profile | Mobihunter" />
          {deleteAlert && (
            <SweetAlert
              showCancel
              confirmBtnText="Delete"
              cancelBtnText="Cancel"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle=""
              title={"Deleting bank details"}
              onCancel={() => setDeleteAlert(false)}
              onConfirm={() => applyDeleteBankDetails(match.params.userId)}
            >
              <p>Are you sure want to delete this bank details?</p>
            </SweetAlert>
          )}

          {editProfile && (
            <EditUserModal
              isOpen={editProfile}
              toggle={closeEditProfile}
              data={profileData}
              positions={positions.results}
              userPatchProfile={userPatchProfile}
              userId={match.params.userId}
              languages={languages}
              permissions={permissions}
            />
          )}

          {editBank && (
            <EditBankModal
              toggle={closeEditBank}
              isOpen={editBank}
              data={editData}
              userId={match.params.userId}
              updateBankDetails={updateBankDetails}
              addBankDetails={addBankDetails}
              deleteDetails={setDeleteAlert}
              permissions={permissions}
            />
          )}

          <Container fluid>
            <Breadcrumbs title="User" breadcrumbItem="Profile" link="/users" />
            <Row className="justify-content-center">
              <Col xl={11}>
                <Card className="mb-0">
                  <CardBody>
                    <Nav
                      tabs
                      className="nav-tabs-custom"
                      style={{
                        width: "80%",
                        borderBottom: "0",
                      }}
                    >
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{ hash: "profile" }}
                          className={classnames("nav-link", {
                            active: toggleTab === "profile",
                          })}
                          onClick={() => {
                            toggle("profile");
                          }}
                        >
                          Profile
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{ hash: "bank" }}
                          className={classnames("nav-link", {
                            active: toggleTab === "bank",
                          })}
                          onClick={() => {
                            toggle("bank");
                          }}
                        >
                          Bank
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{ hash: "payouts" }}
                          className={classnames("nav-link", {
                            active: toggleTab === "payouts",
                          })}
                          onClick={() => {
                            toggle("payouts");
                          }}
                        >
                          Payouts
                        </Link>
                      </NavItem>
                    </Nav>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <TabContent
            activeTab={toggleTab}
            className="text-muted"
            style={{ padding: "20px 12px 0px 12px" }}
          >
            <TabPane tabId="profile">
              <Row className="justify-content-center">
                <Col xl={12}>
                  <ProfilePage
                    positions={positions}
                    languages={languages}
                    setEditProfile={setEditProfile}
                    profileData={profileData}
                    profile_loading={props.profile_loading}
                    permissions={permissions}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="bank">
              <Row className="justify-content-center">
                <Col xl={11}>
                  <Card className="overflow-hidden" style={{ boxShadow: 'none', background: "transparent" }}>
                    {props.loading_details ? "Load": (
                      <BankDetails
                        detailsData={props.bankDetails}
                        permissions={permissions}
                        loading_details={props.loading_details}
                        setEditBank={openEditBank}

                        // data={props.bankCorespondents}
                        // userId={match.params.userId}
                        getBankCorespondents={props.getBankCorespondents}
                        deleteBankCorespondent={props.deleteBankCorespondent}
                        updateBankCorespondent={props.updateBankCorespondent}
                        addBankCorespondent={props.addBankCorespondent}
                        loading_corespondent={props.loading_corespondent}
                        legal_entity_data={props.legal_entity_data}
                        legal_entity_loading={props.legal_entity_loading}
                        updateBankDetails={updateBankDetails}
                        deleteBankDetails={props.deleteBankDetails}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
              {/* <Row className="justify-content-center">
                <Col xl={4}>
                  <Card className="overflow-hidden">
                    {permissions["view_bankdetailsmodel"] && (
                      <BankInformation
                        data={props.bankDetails}
                        setEditBank={setEditBank}
                        loading_details={props.loading_details}
                        permissions={permissions}
                      />
                    )}
                  </Card>
                </Col>

                <Col xl={7}>
                  {permissions["view_bankcorrespondentmodel"] && (
                    <CorrespondentBanks
                      data={props.bankCorespondents}
                      userId={match.params.userId}
                      getBankCorespondents={props.getBankCorespondents}
                      deleteBankCorespondent={props.deleteBankCorespondent}
                      updateBankCorespondent={props.updateBankCorespondent}
                      addBankCorespondent={props.addBankCorespondent}
                      loading_corespondent={props.loading_corespondent}
                      permissions={permissions}
                      legal_entity_data={props.legal_entity_data}
                      legal_entity_loading={props.legal_entity_loading}
                      updateBankDetails={updateBankDetails}
                      bankDetails={props.bankDetails}
                      loading_details={props.loading_details}
                    />
                  )}
                </Col>
              </Row> */}
            </TabPane>
            <TabPane tabId="payouts">
              <Row className="justify-content-center">
                <Col xl={11}>
                  <Card className="overflow-hidden" style={{ padding: 20, minHeight: 420 }}>
                    <SalaryCondition
                      data={{
                        results: profileData.salary_conditions,
                      }}
                      // loader={props.salary_loader}
                      getSalaryConditions={props.getUserSalaryConditions}
                      deleteSalaryCondition={props.deleteUserSalaryConditions}
                      updateSalaryCondition={props.updateUserSalaryConditions}
                      addSalaryCondition={props.addUserSalaryConditions}
                      history={props.history}
                      permissions={props.permissions}
                      user_id={match.params.userId}
                    />
                  </Card>
                </Col>
                <Col xl={11}>
                  <Card className="overflow-hidden" style={{ padding: 20, minHeight: 420 }}>
                    <PayoutCondition
                      data={{
                        results: profileData.payout_conditions,
                      }}
                      // loader={props.payout_loader}
                      getPayoutConditions={props.getUserPayoutConditions}
                      deletePayoutCondition={props.deleteUserPayoutConditions}
                      updatePayoutCondition={props.updateUserPayoutConditions}
                      addPayoutCondition={props.addUserPayoutConditions}
                      history={props.history}
                      permissions={props.permissions}
                      user_id={match.params.userId}
                    />
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      ) : (
        <PreloaderData />
      )}
    </React.Fragment>
  );
};

UserProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  legal_entity_data: PropTypes.shape({
    sizePerPage: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  positions: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  bankDetails: PropTypes.object.isRequired,
  bankCorespondents: PropTypes.shape({
    bank_details: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  loading_corespondent: PropTypes.bool.isRequired,
  loading_details: PropTypes.bool.isRequired,
  profile_loading: PropTypes.bool.isRequired,
  legal_entity_loading: PropTypes.bool.isRequired,
  getPositionsList: PropTypes.func.isRequired,
  updateBankDetails: PropTypes.func.isRequired,
  addBankDetails: PropTypes.func.isRequired,
  userSetProfile: PropTypes.func.isRequired,
  setBankDetailsForUser: PropTypes.func.isRequired,
  deleteBankDetails: PropTypes.func.isRequired,
  getLegalEntityList: PropTypes.func.isRequired,
  getBankCorespondents: PropTypes.func.isRequired,
  deleteBankCorespondent: PropTypes.func.isRequired,
  updateBankCorespondent: PropTypes.func.isRequired,
  addBankCorespondent: PropTypes.func.isRequired,
  userGetProfile: PropTypes.func.isRequired,
  userPatchProfile: PropTypes.func.isRequired,
  getBankDetailsForUser: PropTypes.func.isRequired,
  deleteUserPayoutConditions: PropTypes.func.isRequired,
  updateUserPayoutConditions: PropTypes.func.isRequired,
  getUserPayoutConditions: PropTypes.func.isRequired,
  addUserPayoutConditions: PropTypes.func.isRequired,
  deleteUserSalaryConditions: PropTypes.func.isRequired,
  updateUserSalaryConditions: PropTypes.func.isRequired,
  getUserSalaryConditions: PropTypes.func.isRequired,
  addUserSalaryConditions: PropTypes.func.isRequired,
  payout_data: PropTypes.object.isRequired,
  payout_loader: PropTypes.boolean,
  salary_data: PropTypes.object.isRequired,
  salary_loader: PropTypes.boolean
};

const mapStateToProps = state => ({
  profile: state.User.profile,
  profile_loading: state.User.user_settings_loading,
  bankCorespondents: state.BankCorespondent.data,
  loading_corespondent: state.BankCorespondent.loading,
  bankDetails: state.BankDetails.user_data,
  loading_details: state.BankDetails.loading,
  positions: state.Positions.data,
  legal_entity_data: state.LegalEntityList.data,
  legal_entity_loading: state.LegalEntityList.loading,
  isError: state.User.isError,
  permissions: state.User.permissions,

  payout_data: state.UserPayoutConditions.data,
  payout_loader: state.UserPayoutConditions.loading,
  salary_data: state.UserSalaryConditions.data,
  salary_loader: state.UserSalaryConditions.loading,
});

export default withRouter(
  connect(mapStateToProps, {
    userGetProfile,
    userPatchProfile,
    getPositionsList,
    getBankDetailsForUser,
    updateBankDetails,
    addBankDetails,
    userSetProfile,
    setBankDetailsForUser,
    deleteBankDetails,
    getBankCorespondents,
    deleteBankCorespondent,
    updateBankCorespondent,
    addBankCorespondent,
    getLegalEntityList,
    deleteUserPayoutConditions,
    updateUserPayoutConditions,
    getUserPayoutConditions,
    addUserPayoutConditions,
    deleteUserSalaryConditions,
    updateUserSalaryConditions,
    getUserSalaryConditions,
    addUserSalaryConditions
  })(UserProfile)
);